import React, { Component } from 'react';

//componentes
import ConfiguracionA from './configuracionA'

class Index extends Component {

    render(){
        return(
            <div>
                <ConfiguracionA />
            </div>
        );
    }

}
export default Index;